import React, { Component } from "react";
import {
    Center,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Checkbox,
    Text,
    Input
} from '@chakra-ui/react';

import _ from "lodash"


export default class nabcModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            useOriginalValue: true,
            hasReplacement: false,
            replacementValue: ""
        }
        this.init = this.init.bind(this);
        this.onCheckChange = this.onCheckChange.bind(this);
        this.onReplacementChange = this.onReplacementChange.bind(this);
        this.onSaveButton = this.onSaveButton.bind(this);
    }

    componentDidMount()
    {
        this.init();
    }

    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.data!== this.props.data)
        {
            this.init();
        }
    }

    init()
    {
        this.setState({
            hasReplacement: (this.props.data.hasReplacement) ? this.props.data.hasReplacement: false,
            replacementValue: (this.props.data.replacementValue) ? this.props.data.replacementValue: "",
            useOriginalValue: (this.props.data.hasReplacement) ? (!this.props.data.hasReplacement): false
        })
    }

    onSaveButton(e)
    {
        let clone = _.cloneDeep(this.props.data);
        clone.hasReplacement = this.state.hasReplacement;

        clone.replacementValue = (this.state.hasReplacement) ? this.state.replacementValue: null;
        this.props.onSubmit(clone);
    }

    onCheckChange(e)
    {
        var newUseOriginalValue = (!this.state.useOriginalValue);
        this.setState({
            useOriginalValue: newUseOriginalValue,
            hasReplacement: (!newUseOriginalValue)
        })
    }

    onReplacementChange(value)
    {
        this.setState({
            useOriginValue: false,
            hasReplacement: true,
            replacementValue: value
        });
    }

    render() 
    {
        console.log(this.props.data);
        return (
            <Modal isOpen={this.props.isOpen} onClose={(e) => this.props.onClose(e)} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        Replace Value
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>Property Name: {this.props.data.propName}</Text>
                        <Text>Description: {this.props.data.description}</Text>
                        {(!this.props.data.isReplaceable) ?
                            <Text color="red">Property is not replaceable</Text>
                            : 
                            <Checkbox defaultChecked={this.state.useOriginalValue} onChange={(e) => this.onCheckChange(e)}>Use Original Value</Checkbox> 

                        }
                        {(!this.props.data.isReplaceable) || (this.state.useOriginalValue) ?
                            <span/> :
                            <Input mt='10px'  defaultValue={this.state.replacementValue} placeholder="Enter Value" onChange={(e) => this.onReplacementChange(e.target.value)} />
                        }
                        </ModalBody>
                    <ModalFooter>
                        <Center>
                            {this.props.data.isReplaceable ? <Button colorScheme='blue' mr={3} onClick={(e) => this.onSaveButton(e)}>Save</Button> : <span />}
                            <Button colorScheme='blue' mr={3} onClick={(e) => this.props.onClose(e)}>Close</Button>
                        </Center>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        )

    }
}